import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useKaramiko } from "./context";

// Mico amagat darrere d'un panell: en clicar, treu el cap, suma punt i torna a amagar-se
export default function HiddenMonkey({ spotId }) {
  const { found, findMonkey } = useKaramiko();
  const [peek, setPeek] = useState(false);

  const handle = (e) => {
    e.stopPropagation();
    const isNew = !found.has(spotId);
    findMonkey(spotId);
    setPeek({ isNew });
    setTimeout(() => setPeek(false), 1500);
  };

  return (
    <>
      <button
        type="button"
        onClick={handle}
        aria-label="Toca el panell, potser hi ha un mico amagat"
        className="absolute inset-0 z-20 cursor-pointer rounded-[inherit]"
        data-testid={`monkey-spot-${spotId}`}
      />
      <AnimatePresence>
        {peek && (
          <motion.div
            initial={{ y: 30, opacity: 0, scale: 0.5, rotate: -18 }}
            animate={{ y: -14, opacity: 1, scale: 1, rotate: [0, -12, 12, 0] }}
            exit={{ y: 50, opacity: 0, scale: 0.6 }}
            transition={{ type: "spring", stiffness: 240, damping: 13 }}
            className="pointer-events-none absolute -top-4 left-1/2 z-30 -translate-x-1/2 select-none text-5xl drop-shadow-lg sm:text-6xl"
            data-testid={`monkey-reveal-${spotId}`}
          >
            <span role="img" aria-label="mico">🐒</span>
            {peek.isNew && (
              <motion.span
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: -14 }}
                className="absolute -right-9 top-1 rounded-full bg-terracotta px-2 py-0.5 font-display text-sm font-bold text-paper"
              >
                +1
              </motion.span>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
